import React, { useEffect, useState } from 'react';
import { buildKey } from '@yme/utils/common';
import { AccordionItem } from './AccordionItem';
import { LIGHT_ACCORDION } from './constants';
import { getOpenedItems } from './helpers';
import { AccordionContainer } from './styled';
export function Accordion({ data, isRightToLeft, colorScheme = LIGHT_ACCORDION, preOpenedIndex, onOpened, className, isOneItemOpen = false, hasContainerPadding = true, ItemComponent = AccordionItem, isContentStylesCustom = false, }) {
    const [openedItems, setOpenedItems] = useState(getOpenedItems(data.length, preOpenedIndex));
    useEffect(() => {
        if (data.length && preOpenedIndex !== undefined) {
            setOpenedItems(getOpenedItems(data.length, preOpenedIndex));
        }
    }, [data, preOpenedIndex]);
    const handleClickItem = (index) => {
        return () => {
            const editOpenedItems = openedItems.map((item, i) => {
                if (i === index) {
                    return !item;
                }
                return isOneItemOpen ? false : item;
            });
            const item = data[index];
            if (item !== null && onOpened) {
                if (editOpenedItems[index] === true) {
                    onOpened(item, index);
                }
            }
            setOpenedItems(editOpenedItems);
        };
    };
    return (React.createElement(AccordionContainer, { className: className, colorScheme: colorScheme, isRightToLeft: isRightToLeft, hasContainerPadding: hasContainerPadding }, data.map((item, i) => item ? (React.createElement(ItemComponent, { key: buildKey('key', i + 1), title: item.title, id: item.id, isRightToLeft: isRightToLeft, isOpen: openedItems[i], onClick: handleClickItem(i), isContentStylesCustom: isContentStylesCustom }, item.children)) : null)));
}
Accordion.displayName = 'Accordion_Component';
